// react
import React from 'react';
// third-party
import classNames from 'classnames';
import {
    Link,
    matchPath,
    Redirect,
    Switch,
    Route,
} from 'react-router-dom';
// application
import PageHeader from '../shared/PageHeader';
// pages
import AgentPageDashboard from './AgentPageDashboard';
import AgentPageOrderDetails from './AgentPageOrderDetails';
import AgentPageOrders from './AgentPageOrders';
import AgentPagePassword from './AgentPagePassword';
import AgentPageViewOrder from './AgentviewOrder';
import AgentPageCustomers from './customers';
import AgentPageCommission from './Agentcommission';
import AgentPageSales from './Agentsales';
import AgentPagePayment from './Agentpayment';
import AgentPageMasterPayment from './AgentMasterpayment';
import AgentPageinformation from './AgentPageiMoreinfo';
import AgentPageGeneratedNumber from './generatedMastercontrolNumber';
import AgentPageMasterViewOrder from './masterViewOrders';
import LeadsComponent from './leads'
import Leads from './createLeads';
import ShopPageOutlet from "../shop/shopPageOutlet";
import AgentManualOrder from "./AgentManualOrder";
export default function AgentLayout(props) {
    const { match, location } = props;
    const breadcrumb = [
        { title: 'Home', url: '/agent/dashboard' },
        { title: 'Ezytrade  Smartshop Agent', url: '' },
    ];

    const links = [
        { title: 'Dashboard', url: 'dashboard' },
        {title:  'Customers', url:'customers'},
        { title: 'My Orders', url: 'orders' },
        { title: 'Manual Orders', url: 'manualorder' },
        { title: 'My Leads', url: 'Leads' },
        { title: 'My Sales', url: 'sales' },
        { title: 'Create Master Number', url: 'master/number/pay' },
        {title:'Master Control Number',url:'generated/master/number'},
        { title: 'My Commission', url: 'commission' },
        { title: 'Payment Setting', url: 'payment' },
        { title: 'Change Password', url: 'password' },       
    ].map((link) => {
        const url = `${match.url}/${link.url}`;
        const isActive = matchPath(location.pathname, { path: url, exact: true });
        const classes = classNames('account-nav__item', {
            'account-nav__item--active': isActive,
        });

        return (
            <li key={link.url} className={classes}>
                <Link to={url}>{link.title}</Link>
            </li>
        );
    });
    return (
        <React.Fragment>
            <PageHeader header="Ezytrade Smartshop Agent" breadcrumb={breadcrumb} />

            <div className="block">
                <div className="container">
                    <div className="row">
                        <div className="col-12 col-lg-3 d-flex">
                            <div className="account-nav flex-grow-1">
                                <h4 className="account-nav__title">Navigation</h4>
                                <ul>{links}</ul>
                            </div>
                        </div>
                        <div className="col-12 col-lg-9 mt-4 mt-lg-0">
                            <Switch>
                                <Redirect exact from={match.path} to={`${match.path}/dashboard`} />
                                <Route exact path={`${match.path}/dashboard`} component={AgentPageDashboard} />
                                <Route exact path={`${match.path}/orders`} component={AgentPageOrders} />
                                <Route exact path={`${match.path}/orders/:order`} component={AgentPageOrderDetails} />
                                <Route exact path={`${match.path}/password`} component={AgentPagePassword} />
                                <Route exact path={`${match.path}/vieworder`} component={AgentPageViewOrder} />
                                <Route exact path={`${match.path}/manualorder`} component={AgentManualOrder} />
                                <Route exact path={`${match.path}/customers`} component={AgentPageCustomers}/>
                                <Route exact path={`${match.path}/commission`} component={AgentPageCommission}/>
                                <Route exact path={`${match.path}/more-information`} component={AgentPageinformation}/>
                                <Route exact path={`${match.path}/sales`} component={AgentPageSales}/>
                                <Route exact path={`${match.path}/payment`} component={AgentPagePayment}/>
                                <Route exact path={`${match.path}/generated/master/number`} component={AgentPageGeneratedNumber}/>
                                <Route exact path={`${match.path}/master/number/pay`} component={AgentPageMasterPayment}/>
                                <Route exact path={`${match.path}/leads`} component={LeadsComponent}/>
                                <Route exact path={`${match.path}/leads/:agent_id/:customer_id`}
                                       render={(props) => (
                                           <Leads
                                               {...props}
                                               agent_id={props.match.params.agent_id}
                                               customer_id={props.match.params.customer_id}
                                           />
                                       )}
                                />
                                <Route exact path={`${match.path}/master/number/vieworders`} component={AgentPageMasterViewOrder} />
                            </Switch>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
}